import { Component, OnInit, Input } from '@angular/core';
import { Unity } from 'src/app/models/unity';
import { UnityService } from 'src/app/services/unity.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-unity-card',
  templateUrl: './unity-card.component.html',
  styleUrls: ['./unity-card.component.css']
})
export class UnityCardComponent implements OnInit {
  
  @Input() unity:Unity;
  @Input() showFooter:boolean = true;
  loading: boolean;
  actEditUni: any;
  actDeleteUni: any;
  img:string = '';

  constructor(private unityServ:UnityService, private utl:UtilitiesService, private modalService: NgbModal, private authService:AuthService) { }

  ngOnInit() {
    this.actEditUni = this.authService.can("update-unity");
    this.actDeleteUni = this.authService.can("destroy-unity");

    this.img = environment.baseUrl + '/unities/' + this.unity.id + '/avatar.jpg';
  }

  async delete() {
    try {
      this.loading = true;
      await this.unityServ.deleteUnity(this.unity);
      this.modalService.dismissAll();
      this.unity.active = false;
      this.loading = false;
    } catch(e) {
      this.utl.formatMessages(e);
      this.loading = false;
    }
  }

  show(content) {
    this.modalService.open(content, { size: 'lg' });
  }

}
